module.exports = __webpack_public_path__ + "img/cash-register.38adca26.svg";